module.exports = __webpack_public_path__ + "static/media/email-icon_1.028657db.svg";